import { createContext, useContext } from 'react';

import {
  DEFAULT_PORTAL_LOCALE,
  createPortalTranslate,
  type PortalLocale,
  type PortalTranslate,
} from './portalLocale';

export interface PortalLocaleContextValue {
  locale: PortalLocale;
  /** Saves the choice on this device and applies it at once. */
  setLocale: (locale: PortalLocale) => void;
  t: PortalTranslate;
}

/**
 * Outside the Portal layout (Learn, login, tests that render a component alone)
 * the context falls back to English, so shared components never crash.
 */
const ENGLISH_FALLBACK: PortalLocaleContextValue = {
  locale: DEFAULT_PORTAL_LOCALE,
  setLocale: () => undefined,
  t: createPortalTranslate(DEFAULT_PORTAL_LOCALE),
};

export const PortalLocaleContext = createContext<PortalLocaleContextValue>(ENGLISH_FALLBACK);

export function usePortalLocale(): PortalLocaleContextValue {
  return useContext(PortalLocaleContext);
}
